import api from "./api";

const ItemCategoryService = {
  getAll: async (page = 1, limit = 20, search = "") => {
    const res = await api.get(
      `/itemCategory/getAll?page=${page}&limit=${limit}&search=${search}`
    );
    return res.data;
  },


  // Create category
  create: async (data) => {
    const res = await api.post("/itemCategory/save", data);
    return res.data;
  },

  //  Update category
  update: async (id, data) => {
    const res = await api.put(`/itemCategory/update/${id}`, data);
    return res.data;
  },

  //  Delete category
  delete: async (id) => {
    const res = await api.delete(`/itemCategory/${id}`);
    return res.data;
  },

  getActive: async () => {
    const response = await api.get("/itemCategory/getActive");
    return response.data;
  },

  //  Toggle active/inactive
  updateStatus: async (id) => {
    const res = await api.put(`/itemCategory/updateStatus/${id}`);
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/itemCategory/getById/${id}`);
    return res.data;
  },
};

export default ItemCategoryService;
